module.exports = __webpack_public_path__ + "static/img/OnboardingFinal.4a7b120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OnboardingFinal.png
// module id = NyFt
// module chunks = 1